module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NCIgaGVpZ2h0PSIzOS4wMzYiIHZpZXdCb3g9IjAgMCA1NCAzOS4wMzYiPjxwYXRoIGQ9Ik01NCAzNi4yNzdWMi43NTlMMzUuMzgxIDE5LjUxOHptLTI3LTkuMjE1bC01LjMxNS00Ljc4NS0xOC42MiAxNi43NTloNDcuODdMMzIuMzE2IDIyLjI3N3pNNTAuOTM1IDBIMy4wNjVMMjcgMjEuNTQ0ek0wIDIuNzU5djMzLjUxOGwxOC42MTktMTYuNzU5eiIgZmlsbD0iIzU5QjNDNiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./public/img/headerIcons/shareIconMail.svg
// module id = 95
// module chunks = 0